import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizedHtml'
})
export class SanitizedHtmlPipe implements PipeTransform {

  constructor(
    private domSanitizer: DomSanitizer,
  ) {

  }

  transform(value: any, ...args: unknown[]): unknown {
    return this.domSanitizer.bypassSecurityTrustHtml(value);
  }

}
